<!--  -->
<template>
  <div>
    <div>
      <div class="serch_box search_box">
        <div v-if="type === 3">
          <el-input
            v-model="query.keywords_group"
            clearable
            style="width:200px;margin-right:10px"
            placeholder="请输入群组名字/编号"
          />
        </div>
        <div v-else-if="type === 5">
          <el-input
            v-model="query.group_chat_name_rule"
            clearable
            style="width:200px;margin-right:10px"
            placeholder="请输入拉群规则名称"
          />
        </div>
        <div v-else class="search_box">
          <el-input
            v-model="query.employee_no"
            clearable
            style="width:200px;margin-right:10px"
            placeholder="请输入员工编号"
          />
          <el-input
            v-model="query.name"
            clearable
            style="width:200px;margin-right:10px"
            placeholder="请输入员工名字"
          />
        </div>

        <el-input
          v-if="group_selection === 5"
          v-model="query.spokesman_key_word"
          clearable
          style="width:200px;margin-right:10px"
          placeholder="请输入发言人信息"
        />

        <el-button
          type="primary"
          style="margin:0px 10px"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
        <el-button
          v-if="tag_show"
          type="primary"
          @click="labelUpdate"
        >修改标签组</el-button>
        <el-tag
          v-loading="loadingcount"
          type="danger"
          size="medium"
          style="margin-left:10px;"
        >预计推送人数：{{ count }}</el-tag>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :row-key="rowKey"
      max-height="550"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <el-table-column
        prop="id"
        label="id"
        align="center"
        width="100"
      />
      <el-table-column
        prop="name"
        label="名字"
        align="center"
        width="150"
      />
      <el-table-column
        prop="employee_no"
        label="拉群规则名称(id)"
        align="center"
        width="350"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.chat_set_id!=''">
            {{ scope.row.group_chat_name_rule }}（{{ scope.row.chat_set_id }}）
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="employee_no"
        label="员工编号(企业名称)"
        align="center"
        width="350"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.employee_no!=''">
            {{ scope.row.employee_no }}（{{ scope.row.corp_name }}）
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="group_nickname"
        label="群人数----群名称(id)"
        align="center"
        width="350"
      >
        <template slot-scope="scope">
          <div style="display: flex;flex-wrap: wrap;justify-content: center;">
            <div
              v-for="item,index in scope.row.group_chats"
              :key="index"
              class="sdwr"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.group_chat_name+'('+item.group_chat_id+')'"
                placement="top"
              >
                <div class="gecawe">人数:{{ item.member_num }} ---- {{ item.group_chat_name }}（ {{ item.group_chat_id }}</div>）
              </el-tooltip>

            </div>
            <!-- <div v-for="item,index in 10" :key="index" class="sdwr">
              test check<div class="gecawe">（ wrdsSLO...</div>）
            </div> -->
          </div>

          <!-- <el-popover
            placement="right"
            width="700"
            trigger="click"
          >
            <el-table :data="scope.row.group_chats">
              <el-table-column width="150" property="group_chat_name" align="center" label="群名称" />
              <el-table-column property="group_chat_id" align="center" label="群id" />
            </el-table>
            <el-button slot="reference">click 激活</el-button>
          </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="标签"
        width="180"
        prop="corpId"
      >
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.tag_name"
            placement="top-start"
            title="标签"
            width="200"
            trigger="hover"
            :content="scope.row.tag_name.toString()"
            style="display: flex;"
          >
            <div
              slot="reference"
              style="margin: auto; width:140px; text-overflow: ellipsis; overflow: hidden;white-space: nowrap;  "
            >
              {{ scope.row.tag_name.toString() }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.status == 1"
            class="el-icon-warning defaultrse"
          />
          <i
            v-if="scope.row.status == 2"
            class="el-icon-success defaultr"
          />
          <i
            v-if="scope.row.status == 3"
            class="el-icon-error stopew"
          />
          <i
            v-if="scope.row.status == 4"
            class="el-icon-error fasrw"
          />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="200"
      />
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        align="center"
        width="200"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10,20,50,100]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
      @close="dialogVisible = false"
    >
      <template v-slot:title>
        <span style="font-size: 20px;">修改标签组</span>
        <span style="font-size: 12px; color: red;">（修改标签将会对此策略下所有员工生效）</span>
      </template>
      <div
        class="choiceofficialaccount"
        style="margin-top: 10px;"
      >标签组</div>
      <el-tree
        ref="tree"
        :data="data"
        show-checkbox
        node-key="id"
        highlight-current
        :default-checked-keys="treeCheckedKeys"
        @click="treeChange(this)"
      />
      <el-button
        type="primary"
        @click="updateEmpTag"
      >确定</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </el-dialog>
    <el-button
      type="primary"
      size="mini"
      @click="unbind"
    >解绑</el-button>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { sprbindRecords, sprremoveBind, removeBind, expectedMassCustomersxin, corpUseTag, updEmpTag } from '@/api/officialaccount.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        employee_no: null,
        sp_strategy_no: null,
        name: null,
        keywords_group: null,
        group_chat_name_rule: null,
        spokesman_key_word: null
      },
      selectlist: [],
      selectlistsend: [],
      namearr: [],
      grouparr: [],
      rulearr: [],
      type: null,
      strtext: '',
      push_method: null,
      count: null,
      loadingcount: false,
      dialogVisible: false,
      corp_ids: [],
      data: [],
      treeCheckedKeys: [],
      arrse: [],
      aarwer: [],
      tag_show: false,
      group_selection: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    rowKey(row) {
      return row.id
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.status != 3 // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    async list() {
      this.loading = true
      const data = await sprbindRecords(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      data.data.list.forEach(item => {
        if (!this.corp_ids.includes(item.corp_id)) {
          this.corp_ids.push(item.corp_id)
        }
      })
      this.qunum()
    },
    async qunum() {
      this.loadingcount = true
      const data = await expectedMassCustomersxin({
        sp_strategy_no: this.query.sp_strategy_no,
        push_method: this.push_method
      })
      this.count = data.data.count
      this.loadingcount = false
    },

    // 分页
    fetchPageSize(e) {
      this.query.page = 1
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.employee_no = null
      this.query.name = null
      this.query.keywords_group = null
      this.query.group_chat_name_rule = null
      this.query.spokesman_key_word = null
      this.list()
    },
    send(id, type, push_method, tag_show, group_selection) {
      this.query.sp_strategy_no = id
      this.type = type
      this.push_method = push_method
      this.tag_show = tag_show
      this.group_selection = group_selection
      this.list()
      this.qunum()
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    unbind() {
      if (this.selectlist.length === 0) {
        this.$message.error('请选择需要解绑的人员/群组/规则')
        return
      }

      if (this.selectlist[0].group_selection === 3) {
        this.grouparr = []
        this.grouparr = this.selectlist.map((itemr, indexrs) => {
          // eslint-disable-next-line eqeqeq
          return itemr.group_chats[0].group_chat_name
        })
        this.strtext = ''
        this.strtext = this.grouparr.slice(0, 30).join(',')
      } else if (this.selectlist[0].group_selection === 5) {
        this.rulearr = []
        this.rulearr = this.selectlist.map((itemr, indexrs) => {
          // eslint-disable-next-line eqeqeq
          return itemr.group_chat_name_rule
        })
        this.strtext = ''
        this.strtext = this.rulearr.slice(0, 30).join(',')
      } else {
        this.namearr = []
        this.namearr = this.selectlist.map((itemr, indexrs) => {
          // eslint-disable-next-line eqeqeq
          return itemr.name
        })
        this.strtext = ''
        this.strtext = this.namearr.slice(0, 30).join(',')
      }
      this.$confirm(`确定解绑 ${this.strtext} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          if (this.selectlist[0].group_selection === 3) {
            this.selectlistsend = []
            this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
              // eslint-disable-next-line eqeqeq
              return itemr.group_chat_id
            })
            removeBind({
              sp_strategy_no: this.query.sp_strategy_no,
              group_chat_ids: this.selectlistsend
            }).then(res => {
              // this.$emit('updata')
              this.list()
              this.$message({
                message: '解绑成功',
                type: 'success'
              })
              this.$refs.multipleTable.clearSelection()
            })
          } else if (this.selectlist[0].group_selection === 5) {
            this.selectlistsend = []
            this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
              // eslint-disable-next-line eqeqeq
              return itemr.chat_set_id
            })
            removeBind({
              sp_strategy_no: this.query.sp_strategy_no,
              chat_set_ids: this.selectlistsend
            }).then(res => {
              // this.$emit('updata')
              this.list()
              this.$message({
                message: '解绑成功',
                type: 'success'
              })
              this.$refs.multipleTable.clearSelection()
            })
          } else {
            this.selectlistsend = []
            this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
              // eslint-disable-next-line eqeqeq
              return itemr.employee_no
            })
            sprremoveBind({
              sp_strategy_no: this.query.sp_strategy_no,
              employee_nos: this.selectlistsend
            }).then(res => {
              // this.$emit('updata')
              this.list()
              this.$message({
                message: '解绑成功',
                type: 'success'
              })
              this.$refs.multipleTable.clearSelection()
            })
          }
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    labelUpdate() {
      this.dialogVisible = true
      this.getlabelList()
    },
    getlabelList() {
      corpUseTag({
        corp_ids: this.corp_ids,
        strategy_no: this.query.sp_strategy_no
      }).then(res => {
        this.alltagarr = []
        for (let i = 0; i < res.data.length; i++) {
          this.alltagarr.push({
            id: res.data[i].corp_id,
            label: res.data[i].corp_name
          })
        }
        for (let l = 0; l < this.alltagarr.length; l++) {
          this.alltagarr[l].children = []
        }
        for (let i = 0; i < res.data.length; i++) {
          for (let k = 0; k < res.data[i].children.length; k++) {
            this.alltagarr[i].children.push({
              id: res.data[i].children[k].group_id,
              label: res.data[i].children[k].group_name
            })
          }
        }

        for (let r = 0; r < this.alltagarr.length; r++) {
          for (let x = 0; x < this.alltagarr[r].children.length; x++) {
            this.alltagarr[r].children[x].children = []
          }
        }
        for (let u = 0; u < res.data.length; u++) {
          for (let f = 0; f < res.data[u].children.length; f++) {
            for (let g = 0; g < res.data[u].children[f].children.length; g++) {
              this.alltagarr[u].children[f].children.push({
                id: res.data[u].children[f].children[g].tag_id,
                label: res.data[u].children[f].children[g].tag_name,
                corp_id: res.data[u].children[f].children[g].corp_id,
                tag_id: res.data[u].children[f].children[g].tag_id
              })
            }
          }
        }
        this.data = this.alltagarr
        this.treeCheckedKeys = this.findCheckedKeys(res.data)
      })
    },
    async updateEmpTag() {
      if (this.$refs.tree.getCheckedNodes().length === 0 && this.group_value) {
        this.$message({
          message: '请选择标签',
          type: 'error'
        })
        return
      }
      this.arrse = this.fnTree(this.data).map(item => {
        return item.id
      })
      const tag_ids = this.$refs.tree.getCheckedKeys(true)
      updEmpTag({
        sp_strategy_no: this.query.sp_strategy_no,
        change_tags: tag_ids
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.aarwer = []
          this.dialogVisible = false
          this.list()
        }
      })
    },
    // 递归函数用于查找叶子节点，并根据 can_checked 构建 checkedKeys
    findCheckedKeys(nodes) {
      let checkedKeys = []
      nodes.forEach(node => {
        if (node.children && node.children.length > 0) {
          // 递归查找子节点
          checkedKeys = checkedKeys.concat(this.findCheckedKeys(node.children))
        } else if (node.can_checked === 9) {
          // 如果是叶子节点且 can_checked 为 9，加入 checkedKeys
          checkedKeys.push(node.tag_id) // 这里的 tag_id 是节点的唯一标识
        }
      })
      return checkedKeys
    },
    fnTree(arr) {
      // 取树状数据的所有子集
      return arr.reduce((prev, cur) => {
        return prev.concat(cur.children && cur.children.length ? this.fnTree(cur.children) : cur)
      }, [])
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.serch_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.sdwr {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.gecawe {
  display: inline-block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.titip {
  margin: 0 auto;
}
</style>
